import fetchData from './fetchData'
import { parseJSON, checkHttpStatus } from '../shared/utils'
import config from '../config/index'

async function goodsList(params, payload) {
  const { search, sort, order } = params

  return fetchData(
    `${config.api.baseUrl}?class=goods&action=list&search=${search || ''}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

export { goodsList }



// WEBPACK FOOTER //
// src/api/goods.js